module.exports = __webpack_public_path__ + "img/first 12 waltzes cover.a6ecaae3.jpg";